import { Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { classNames, filled, usePrevious, isSet, t } from '@/components/common/Helpers'
import { guestbookEntity } from '../store/root'
import { Dialog, Transition } from '@headlessui/react'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import { Carousel } from 'react-responsive-carousel'
import GuestbookItem from './GuestbookItem'
import GuestbookForm from './GuestbookForm'
import Skeleton from 'react-loading-skeleton'
import Masonry from 'react-masonry-css'
import { BsFacebook, BsTwitter } from 'react-icons/bs'
import { useForm } from 'react-hook-form'
import InfiniteScroll from 'react-infinite-scroller'
import PropTypes from 'prop-types'
import { isAppInMaintenanceMode } from '@/components/common/Helpers'

function GuestbookApp(guestBookProps) {

    const {
        guestbook,
        guestbookList,
        guestbookCreateLoading
    } = useSelector(state => state.guestbookReducer)

    const { obituary } = useSelector(state => state.obituaryReducer)


    const [obituaryPost, setObituaryPost] = useState(null)
    const [postCreated, setPostCreated] = useState(false)
    const [leadImage, setLeadImage] = useState('')
    const [adGroupFormLink, setAdGroupFormLink] = useState(null)

    const previous = usePrevious({ guestbookCreateLoading })

    const dispatch = useDispatch()

    const refresh = (page) => {
        dispatch(guestbookEntity.services.findAll({ ...(page && { page: page }) }, { append: true }))
    }

    const breakpointColumnsObj = {
        default: 3,
        768: 2,
        500: 1
    }
    const methods = useForm({
        defaultValues: {
            name: '',
            obituary_id: obituary?.id,
            organization_id: null,
            ad_group_id: null,
            ad_group_asset_id: null,
            email: '',
            phone: '',
        }
    })

    useEffect(() => {
        // const currentAsset = collect(obituary?.ad_group?.ad_group_assets).filter(ag => ag.type === AdGroupTypes?.Website?.Value).first()
        if (filled(obituary?.ad_group_banner)) {
            const url = obituary.ad_group_banner.asset_image
            // methods.setValue('ad_group_asset_id', currentAsset.id)
            if (filled(url)) {
                setLeadImage(url)
            } else {
                setLeadImage('')
            }
        } else {
            setLeadImage('')
        }
        // methods.setValue('obituary_id', obituary?.id)
        // methods.setValue('organization_id', obituary?.ad_group?.organization_id)
        // methods.setValue('ad_group_id', obituary?.ad_group?.id)
    }, [obituary])

    useEffect(() => {
        if (filled(obituary?.ad_group_banner)) {
            const params = new URLSearchParams()
            params.append('oid', obituary.id)

            if (guestbook?.name) {
                params.append('name', guestbook.name)
            }

            if (guestbook?.email) {
                params.append('email', guestbook.email)
            }
            setAdGroupFormLink(obituary.ad_group_banner.url + `?${params.toString()}`)
        }

        methods.setValue('name', guestbook?.name)
        methods.setValue('email', guestbook?.email)
    }, [guestbook])

    useEffect(() => {
        if (obituary && !guestbookCreateLoading && previous?.guestbookCreateLoading) {
            setPostCreated(true)
        }
    }, [obituary, guestbookCreateLoading])

    return (
        <>
            {obituary &&
                <>
                    {(!guestBookProps.disableObituaryPosts && !isAppInMaintenanceMode()) && (
                        <div className="border border-gray p-8 rounded-md bg-white mb-8">

                            {!guestbookCreateLoading ? (
                                <>
                                    {postCreated ? (
                                        <div className={classNames('grid grid-cols-1 gap-8', filled(leadImage) ? 'md:grid-cols-2' : '')}>
                                            <div className="text-center italic text-xl font-serif">
                                                <p className="mb-2">{t.trans('guestbook.thank')}
                                                    {!guestbook?.is_approved &&
                                                        <span className="block text-lg">{t.trans('guestbook.review')}</span>
                                                    }
                                                </p>
                                                {guestbook &&
                                                    <>
                                                        <p className="text-sm uppercase mb-2">{t.trans('guestbook.preview')}</p>
                                                        <div className="flex justify-center font-sans">
                                                            <GuestbookItem post={guestbook} setObituaryPost={setObituaryPost} className="text-left w-full md:w-1/2 border border-gray-100 shadow not-italic" />
                                                        </div>

                                                        {guestbook.subscription_pending_verification &&
                                                            <>
                                                                <div className="pt-8">{t.trans('guestbook.check-email')}</div>
                                                                <p className="text-base font-sans not-italic text-gray-500">{t.trans('guestbook.confirm-sub')}</p>
                                                            </>
                                                        }
                                                    </>
                                                }
                                                {guestbook?.urls &&
                                                    <>
                                                        <div className="pt-8 pb-4">{t.trans('guestbook.share')}</div>
                                                        <div className="flex justify-center gap-x-4">
                                                            <a href={guestbook.urls.fb_share_link} rel="noreferrer" target="_blank">
                                                                <BsFacebook className="w-12 h-12 text-gray-400 hover:text-blue-700" />
                                                            </a>
                                                            <a href={guestbook.urls.twitter_share_link} rel="noreferrer" target="_blank">
                                                                <BsTwitter className="w-12 h-12 text-gray-400 hover:text-blue-400" />
                                                            </a>
                                                        </div>
                                                    </>
                                                }
                                            </div>
                                            {filled(leadImage) &&
                                                <a href={adGroupFormLink} target="_blank" rel="noreferrer">
                                                    <img loading="lazy"
                                                        className="cursor-pointer h-full"
                                                        alt="Lead Generation Image"
                                                        src={leadImage}
                                                    />
                                                </a>
                                            }
                                        </div>
                                    ) : (
                                        <GuestbookForm primaryButtonClasses={guestBookProps.primaryButtonClasses} secondaryButtonClasses={guestBookProps.secondaryButtonClasses}/>
                                    )}
                                </>
                            ) : (
                                <Skeleton height={25} count={3} />
                            )}
                        </div>
                    )}

                    {(!guestBookProps.disableObituaryPosts && isAppInMaintenanceMode()) && (
                        <div className="flex flex-col items-center justify-center py-8 bg-gray-50 border border-gray-200 rounded-lg shadow-lg mb-8">
                            <p className="text-xl font-semibold text-gray-700">{t.trans('guestbook.unavailable')} </p>
                            <p className="mt-2 text-base text-gray-600 text-center">{t.trans('guestbook.unavailable-msg')}</p>
                        </div>
                    )}

                    <InfiniteScroll
                        pageStart={0}
                        loadMore={refresh}
                        initialLoad={false}
                        hasMore={!isSet(guestbookList) || guestbookList.current_page < guestbookList.last_page}
                        loader={<Skeleton key={1} height={25} count={3} />}
                    >
                        <Masonry breakpointCols={breakpointColumnsObj}
                            className="twp-masonry-grid"
                            columnClassName="twp-masonry-grid_column"
                        >
                            {guestbookList?.data?.map(post => (
                                <GuestbookItem 
                                    key={post.id} 
                                    post={post} 
                                    setObituaryPost={setObituaryPost} 
                                    textClasses={guestBookProps.guestbookTextClasses}
                                    nameClasses={guestBookProps.guestbookNameClasses}
                                />
                            ))}

                        </Masonry>
                    </InfiniteScroll>
                </>
            }
        </>
    )
}

GuestbookApp.propTypes = {
    disableObituaryPosts: PropTypes.bool,
    primaryButtonClasses: PropTypes.string,
    secondaryButtonClasses: PropTypes.string,
    guestbookTextClasses: PropTypes.string,
    guestbookNameClasses: PropTypes.string
}

export default GuestbookApp
